module.exports = __webpack_public_path__ + "static/media/bottom.aea50599.png";